import { gql } from '@apollo/client';
import list from './List';

export default {
  name: 'pro_pool_professionals',
  inputShow: gql`
    query getProPoolDashboard($input: ProPoolDashboardInput) {
      getProPoolDashboard(input: $input) {
        id
        __typename
      }
    }
  `,
  list,
  show: {},
  options: {
    group: 'Misc',
    label: 'Pro Pool Professionals',
  },
};
